module.exports = __webpack_public_path__ + "137db8f0797b3986bf32b5f10ebd83f8.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-1080.webp
// module id = 358
// module chunks = 0